import { render, staticRenderFns } from "./PendingEditRequestMentoringLanguageItemValues.vue?vue&type=template&id=51b8bb26&scoped=true&"
import script from "./PendingEditRequestMentoringLanguageItemValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestMentoringLanguageItemValues.vue?vue&type=script&lang=js&"
import style0 from "./PendingEditRequestMentoringLanguageItemValues.vue?vue&type=style&index=0&id=51b8bb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8bb26",
  null
  
)

export default component.exports